import { __rest } from "tslib";
import * as React from "react";
import { forwardRef } from "react";
import clsx from 'clsx';
const _CheckIcon = (_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("svg", Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", role: "presentation", width: 16, height: 16, className: clsx("cmp-icon", className), ref: ref }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M20.707 6.293a1 1 0 0 1 0 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 16.586 19.293 6.293a1 1 0 0 1 1.414 0Z", clipRule: "evenodd" }));
};
const CheckIcon = forwardRef(_CheckIcon);
export default CheckIcon;
//# sourceMappingURL=check.js.map